module.exports = __webpack_public_path__ + "img/avatar3.df7425b1.png";